<template>
  <div class="about">
    <Banner :classType="1" />
    <Menu :lang="lang" />

    <div v-show="showENO">
      <div
        class="pageTitle wow animate__slideInUp"
        :class="{ titleEn: lang == 'en' }"
      >
        <h2>公司介绍</h2>
        <p>BRIEF INTRODUCTION</p>
      </div>

      <div class="wrap aboutCom wow animate__slideInUp">
        <div>
          <!-- <p>
          中复神鹰炭纤维股份有限公司成立于2006年，注册资本8亿元，目前累计总投资50亿元，隶属于国务院国资委管理的世界500强企业——中国建材集团有限公司，是集碳纤维及复合材料研发、生产、销售为一体的国家级高新技术企业。现有连云港、西宁和上海三个基地，产能规模超万吨，位居国内首位。
        </p>
        <p>
          公司自主建成了全套碳纤维生产系统，在关键技术、核心装备等方面具有完全自主知识产权，率先突破先进的干喷湿纺碳纤维并实现产业化。SYT49（T700级）及以上高端产品连年在国产碳纤维市场占有率达到50%以上，下游客户达到500余家，成为国内外具有影响力的碳纤维供应商之一。
        </p> -->
          <p v-html="changeValue(Summary)"></p>
        </div>
        <!-- :src="require('@/assets/images/aboutTmp.jpg')" -->
        <!--   <el-image :src="PicUrl" fit="contain"></el-image> -->

        <div class="aboutVideo wow animate__slideInUp" >
          <div class="wrap">
            <ul class="videoUL2">
              <li>
                <video
                  class="videoImg"
                  :src="videoUrl"
                  :poster="videoPic"
                  controls="controls"
                ></video>
                <span>{{ videoTit }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="aboutNumBox wow animate__slideInUp" ref="num" id="num">
        <ul class="aboutNum" style="margin-top:30px;">
          <li :key="idx" v-for="(item, idx) in CompanyDatas">
            <div class="line">
              <span
                ><strong>
                  <countTo
                    :ref="`one${idx}`"
                    :startVal="0"
                    :endVal="item.Number"
                    :duration="2000"
                    :autoplay="false"
                    separator=""
                  ></countTo> </strong
                >{{ item.Unit }}</span
              >
              <span>{{ item.Title }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="aboutVideo wow animate__slideInUp" v-if="lang=='zh'">
        <div class="wrap">
          <ul class="videoUL2">
            <li
              :key="idx"
              v-for="(item, idx) in Videos"
            >
         
              <video
                class="videoImg"
                :src="item.Url"
                controls="controls"
              ></video>
              <span>{{ item.Title }}</span>
            </li>
          </ul>
        </div>
      </div> -->

    <div v-show="showENC" v-if="lang == 'en'">
      <div class="wrap aboutTxt" ref="note" id="note">
        <div
          class="pageTitle wow animate__slideInUp"
          :class="{ titleEn: lang == 'en' }"
        >
          <h2>企业文化</h2>
          <p>CORPORATE CULTURE</p>
        </div>

        <ul class="aboutUl wow animate__slideInUp">
          <li>
            <h3>{{ cultureObj.Title1 }}</h3>
            <h4>{{ cultureObj.CultureInfo1.Item1 }}</h4>
            <p>{{ cultureObj.CultureInfo1.Item2 }}</p>
          </li>
          <li>
            <h3>{{ cultureObj.Title2 }}</h3>
            <h4>{{ cultureObj.CultureInfo2.Item1 }}</h4>
            <p>{{ cultureObj.CultureInfo2.Item2 }}</p>
          </li>
        </ul>
        <div class="aboutOth wow animate__slideInUp">
          <h3>{{ cultureObj.Title3 }}</h3>
          <h4>{{ cultureObj.SubTitle3 }}</h4>
          <ul class="aboutUlIcon">
            <li :key="idx" v-for="(item, idx) in cultureObj.CultureInfo3">
              <span class="icon" :class="`iconImg${idx == 0 ? '' : idx + 1}`"
                >图片</span
              >
              <div>
                <h3>{{ item.Item1 }}</h3>
                <p>{{ item.Item2 }}</p>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <div class="wrap aboutBBox wow animate__slideInUp">
        <div class="fullBox">
          <h4>{{ CulturePicInfo.Title }}</h4>
          <p>{{ CulturePicInfo.SubTitle }}</p>
        </div>
        <el-image
          :src="CulturePicInfo.PicUrl"
          fit="contain"
          class="aboutB"
        ></el-image>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "./about/Menu";
import countTo from "vue-count-to";
import { WOW } from "wowjs";
import { changeText } from "@/utils/tool";
import Banner from "@/views/components/Banner";
import cookie from "cookiejs";

export default {
  name: "about",
  data() {
    return {
      type: this.$route.query.type || "",
      animate: false,
      classObject: {
        animate__animated: this.animate,
        animate__flipInX: this.animate,
      },
      startVal: 0,
      endVal: 100,
      autoplay: false,
      Summary: "",
      PicUrl: "",
      CompanyDatas: [],
      Videos: [],
      refName: ["one", "two", "three", "four"],
      CulturePicInfo: {
        PicUrl: "",
      },
      cultureObj: {
        CultureInfo1: {},
        CultureInfo2: {},
        CultureInfo3: {},
      },
      lang: "cn",
      showENO: true,
      showENC: true,
      videoTit: "",
      videoPic: "",
      videoUrl:"",
    };
  },
  components: {
    Menu,
    countTo,
    Banner,
  },
  methods: {
    changeValue(value) {
      return changeText(value);
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      // let offsetTop = document.querySelector("#num").offsetTop;
      if (this.$refs.num) {
        let numOffsetTop = this.$refs.num.offsetTop;
        if (scrollTop >= numOffsetTop - 600 && this.autoplay == false) {
          // this.animate = true;
          this.$refs.one0[0].start();
          this.$refs.one1[0].start();
          this.$refs.one2[0].start();
          this.$refs.one3[0].start();
          this.autoplay = true;
        }
      }
    },
    handleScroll2() {
      let note = parseInt(this.$refs.note.offsetTop);
      let meshine = navigator.userAgent;
      var element =
        meshine.indexOf("Weixin") == -1
          ? document.documentElement
          : document.body;

      element.scrollTop = note - 60;
    },
    changeShow() {
      if (this.lang == "en") {
        if (this.type == "my") {
          this.showENC = false;
          this.showENO = true;
        }
        if (this.type == "culture") {
          this.showENO = false;
          this.showENC = true;
        }
      }
    },
  },
  created() {
    this.lang = cookie.get("lang");
    this.$watch(
      () => this.$route.params,
      (toParams, previousParams) => {
        // 对路由变化做出响应...
        this.type = this.$route.params.type;
        if (this.type == "culture") {
          this.handleScroll2();
        }
        this.changeShow();
      }
    );
  },
  mounted() {
    this.type = this.$route.params.type;
    this.changeShow();
    this.$api.about({}).then((res) => {
      const { Summary, CompanyDatas, Title, PicUrl,VideoUrl } = res.Value;
      console.log(res,"++++about")
      this.Summary = Summary;
     
      this.CompanyDatas = CompanyDatas;
      this.videoTit = Title;
      this.videoPic = PicUrl;
      this.videoUrl = VideoUrl;
      this.type = this.$route.params.type;
      new WOW({
        boxClass: "wow",
        animateClass: "animate__animated",
        offset: 100,
        live: false,
      }).init();

      window.addEventListener("scroll", this.handleScroll);

      this.$api.culture().then((res) => {
        const { CulturePicInfo, ...rest } = res.Value;
        this.CulturePicInfo = CulturePicInfo;
        this.cultureObj = rest;
        if (this.type == "culture") {
          setTimeout(this.handleScroll2(), 5000);
        }
      });
    });
  },
};
</script>

<style lang="scss">
.aboutCom {
  padding-top: 50px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 50px;
  align-items: start;
  p {
    margin: 0 0 40px 0;
    line-height: 25px;
    color: #000!important;
  }
}
.aboutNumBox {
  background: #f5f5f5;
  margin-bottom: 20px;
}
.aboutNum {
  display: flex;
  justify-content: space-around;
  width: 1280px;
  margin:50px auto 0;
  li {
    width: 25%;
    padding: 80px 0;
    align-items: center;
    text-align: center;
    .line {
      border-right: 1px solid #8a8a8a;
    }
    &:last-child {
      .line {
        border: none;
      }
    }
    span {
      display: block;
      strong {
        font-size: 36px;
        font-weight: 200;
        margin-right: 5px;
        display: inline-block;
      }
    }
  }
}
.aboutTxt {
  color: #0b1322;
  .aboutUl {
    margin-top: 50px;
    padding-top: 40px;
    margin-bottom: 40px;
    border: 1px solid #8a8a8a;
    border-right: none;
    border-left: none;
  }
  li {
    h3 {
      font-size: 24px;
      font-weight: 500;
      margin: 0 0 20px 0;
      padding: 0;
    }
    h4 {
      font-size: 26px;
      font-weight: 200;
      margin: 0;
      padding: 0;
    }
  }
  p {
    margin: 0;
    padding: 0;
  }
  li {
    margin-bottom: 50px;
  }
  .aboutOth {
    h3 {
      font-size: 24px;
      font-weight: 500;
      margin: 0 0 20px 0;
      padding: 0;
    }
    h4 {
      font-size: 26px;
      font-weight: 200;
      margin: 0;
      padding: 0;
    }
  }
}
.aboutUlIcon {
  margin-top: 30px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 30px;
  li {
    display: grid;
    grid-template-columns: 120px auto;
    h3 {
      // font-weight: 300 !important;
    }
    .icon {
      transition: all 0.3s;
      width: 100px;
      height: 100px;
      overflow: hidden;
      border: 1px solid #ddd;
      border-radius: 50%;
      text-indent: -1000px;
    }
    &:hover {
      .icon {
        animation: pulse;
        animation-duration: 1s;
      }
      .iconImg {
        background: #ff0000 url("~@/assets/images/iconW.png") center center
          no-repeat;
        background-size: contain;
      }
      .iconImg2 {
        background: #ff0000 url("~@/assets/images/icon2W.png") center center
          no-repeat;
        background-size: contain;
      }
      .iconImg3 {
        background: #ff0000 url("~@/assets/images/icon3W.png") center center
          no-repeat;
        background-size: contain;
      }
      .iconImg4 {
        background: #ff0000 url("~@/assets/images/icon4W.png") center center
          no-repeat;
        background-size: contain;
      }
    }

    .iconImg {
      background: url("~@/assets/images/icon.png") center center no-repeat;
      background-size: contain;
    }
    .iconImg2 {
      background: url("~@/assets/images/icon2.png") center center no-repeat;
      background-size: contain;
    }
    .iconImg3 {
      background: url("~@/assets/images/icon3.png") center center no-repeat;
      background-size: contain;
    }
    .iconImg4 {
      background: url("~@/assets/images/icon4.png") center center no-repeat;
      background-size: contain;
    }
  }
}
.aboutBBox {
  position: relative;
  color: #fff;
  h4 {
    font-weight: 500 !important;
    padding-bottom: 20px;
  }
  h4,
  p {
    text-align: center;
    width: 100%;
    color: #fff;
    z-index: 9;
    font-weight: 200;
    font-size: 24px;
    text-align: center;
  }
  p {
    font-size: 28px;
    top: 45%;
  }
}
.aboutB {
  margin-bottom: 40px;
}
.code {
  margin-bottom: 10px;
}
.fullBox {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
}
.videoUL2 {
 
  overflow: hidden;
  li {
    width: 100%;
    margin-bottom: 10px;
    .videoImg {
      width: 100%;
    }
    span {
      padding: 10px 0;
      text-align: center;
      display: block;
      font-size: 18px;
    }
  }
}
.aboutVideo {
  video {
    height: 450px;
  }
}
@media (max-width: 750px) {
  .aboutVideo {
    margin-bottom: -25px;
    .wrap {
      padding: 0;
    }
    .videoUL2 {
      margin: 20px 0;
    }
    video {
      height: 260px;
      margin-top: -20px;
    }
  }
}
</style>
